import { render, staticRenderFns } from "./DbFabList.vue?vue&type=template&id=6972d522&scoped=true&"
import script from "./DbFabList.vue?vue&type=script&lang=ts&"
export * from "./DbFabList.vue?vue&type=script&lang=ts&"
import style0 from "./DbFabList.vue?vue&type=style&index=0&id=6972d522&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6972d522",
  null
  
)

export default component.exports